import { render } from "./LoginModal.vue?vue&type=template&id=a3017bde&scoped=true&ts=true"
import script from "./LoginModal.vue?vue&type=script&lang=ts"
export * from "./LoginModal.vue?vue&type=script&lang=ts"

import "./LoginModal.vue?vue&type=style&index=0&id=a3017bde&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3017bde"]])

export default __exports__